import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import Wizard, { Step } from 'components/Wizard';
import { Dispatch } from 'redux/types';
import VideoWizardProgressStep, {
  VideoWizardProgressStepProps,
} from '../VideoWizardProgressStep';
import { openNewProject } from './actions';
import { VideoFlowInternalErrorHandler, VideoFlowStep } from './types';

export type UseProgressStepProps = Pick<
  VideoWizardProgressStepProps,
  'isFullEpisode' | 'objective'
> & {
  onError: VideoFlowInternalErrorHandler;
  wizardRef: React.RefObject<Wizard>;
};

export default function useProgressStep(props: UseProgressStepProps) {
  const { isFullEpisode, objective } = props;
  const { wizardRef, ...progressStepProps } = props;
  const dispatch = useDispatch<Dispatch>();

  const handleCompleted = useCallback(() => {
    dispatch(openNewProject());
  }, [dispatch]);

  const handleExportStart = useCallback(() => {
    wizardRef.current?.next();
  }, [wizardRef]);

  const step: Step<VideoFlowStep.PROGRESS> = {
    name: 'loading',
    component: (
      <VideoWizardProgressStep
        {...progressStepProps}
        clipSelectionMode={isFullEpisode ? 'full-episode' : 'clip'}
        isSingleClip={objective === 'SingleClip'}
        onCompleted={handleCompleted}
        onVideoExportStart={handleExportStart}
      />
    ),
    renderCancelButton: () => null,
    renderNextButton: () => null,
    showInNav: false,
    stepId: VideoFlowStep.PROGRESS,
  };

  return {
    step,
  };
}
